import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=2a4e882c&"
import script from "./StudentsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports